import React, { ReactNode } from 'react';
import Modal from '../modal/Modal';
import { Header, Divider, Button } from '..';
import { Flex, Box } from '@rebass/grid';

interface AlertProps {
    confirmButtonId: string;
    onCancel: () => void;
    onAccept: () => void;
    acceptText: string;
    cancelText: string;
    isOpen: boolean;
    children: ReactNode;
}

function Alert(props: AlertProps) {
    return <Modal testId={'alert'} width={490} height={200} isOpen={props.isOpen} onRequestClose={props.onCancel}>
        <React.Fragment>
            <Header>Confirm your action</Header>
            <Box my={30}>
                {props.children}
                <Box mt={20}><Divider /></Box>
            </Box>
            <Flex justifyContent="flex-end">
                <Flex width="40%" justifyContent="space-between">
                    <Button id='button-confirm-cancel' onClick={props.onCancel} kind='secondary'>cancel</Button>
                    <Button id={`button-confirm-${props.confirmButtonId}`} onClick={props.onAccept} kind='primary'>{props.acceptText}</Button>
                </Flex>
            </Flex>
        </React.Fragment>
    </Modal>;
}

export default Alert;
